import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import type { Cliente } from '../../shared/api/tipos.ts';

/**
 * O mesmo seletor nas duas abas que consultam uma loja por vez.
 *
 * Ele existe para que a aba continue utilizável sem passar pela lista: um
 * cliente que não tem nota rejeitada nenhuma não aparece na primeira aba, mas
 * pode muito bem ter um buraco na numeração — e quem desconfia disso precisa
 * poder escolhê-lo direto.
 */
export function SeletorDeCliente({
  clientes,
  carregando,
  empresaId,
  aoEscolher,
  ajuda,
}: {
  clientes: readonly Cliente[];
  carregando: boolean;
  empresaId: string | null;
  aoEscolher: (empresaId: string | null) => void;
  ajuda: string;
}) {
  const escolhido = clientes.find((cliente) => cliente.id === empresaId) ?? null;

  return (
    <Autocomplete
      options={clientes}
      value={escolhido}
      onChange={(_, cliente) => aoEscolher(cliente?.id ?? null)}
      getOptionLabel={(opcao) => opcao.razaoSocial}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      loading={carregando}
      noOptionsText="Nenhum cliente cadastrado."
      sx={{ minWidth: { md: 320 }, flexGrow: 1 }}
      renderInput={(parametros) => (
        <TextField {...parametros} label="Cliente" placeholder="Escolha o cliente" helperText={ajuda} />
      )}
      renderOption={(parametros, opcao) => {
        const { key, ...resto } = parametros;
        return (
          <li key={key} {...resto}>
            <Stack>
              <Typography variant="body2">{opcao.razaoSocial}</Typography>
              <Typography variant="caption" color="text.secondary">
                {opcao.cnpjFormatado}
              </Typography>
            </Stack>
          </li>
        );
      }}
    />
  );
}
